import React from "react";
import { Box, Divider, Grid, Link, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import facebook from "../../Logo/icons8-facebook-16.png";
import x from "../../Logo/icons8-twitterx-16.png";
import insta from "../../Logo/icons8-instagram-16.png";
import { useHistory } from "react-router-dom";

const Footer = ({ setIsFormOpen }) => {
  const history = useHistory();

  const links = [
    { label: "Construction", path: "/construction" },
    { label: "Real Estate", path: "/real-estate" },
    { label: "About Us", path: "/about-us" },
    { label: "Careers", path: "/careers" },
  ];

  const socialLinks = [
    {
      label: "Facebook",
      href: "https://www.facebook.com/HOMELYSOLUTION",
      icon: facebook,
    },
    { label: "X", href: "https://x.com", icon: x },
    {
      label: "Instagram",
      href: "https://www.instagram.com/homelys_/#",
      icon: insta,
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 3, md: 8 },
        pt: { xs: 6, md: 8 },
        pb: 2.5,
        color: "#f6f4ef",
        backgroundColor: "#292720",
      }}
    >
      <Grid
        container
        columnSpacing={{ xs: 3, md: 7 }}
        rowSpacing={{ xs: 4, md: 5 }}
        sx={{ pb: { xs: 5, md: 7 } }}
      >
        <Grid item xs={12} md={4}>
          <Typography
            component="p"
            sx={{
              mb: 2,
              color: "#c7b896",
              fontSize: "0.67rem",
              fontWeight: 600,
              letterSpacing: "0.18em",
            }}
          >
            HOMELY BUILDOFIY
          </Typography>
          <Typography
            sx={{
              maxWidth: 360,
              color: "rgba(246,244,239,0.76)",
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: { xs: "1.65rem", md: "2rem" },
              lineHeight: 1.3,
            }}
          >
            Thoughtfully built for the way you live.
          </Typography>
          <Typography
            sx={{
              mt: 3,
              maxWidth: 340,
              color: "rgba(246,244,239,0.58)",
              fontSize: "0.86rem",
              lineHeight: 1.8,
            }}
          >
            Old NH-6, near Bandutikra Chowk, Bargarh, Odisha 768028
          </Typography>
        </Grid>

        <Grid item xs={6} sm={4} md={2.5}>
          <Typography className="footer-heading">Explore</Typography>
          <Box sx={{ display: "grid", gap: 1.4 }}>
            {links.map((link) => (
              <Link
                key={link.path}
                component="button"
                onClick={() => history.push(link.path)}
                underline="none"
                sx={footerLinkStyles}
              >
                {link.label}
              </Link>
            ))}
          </Box>
        </Grid>

        <Grid item xs={6} sm={4} md={2.5}>
          <Typography className="footer-heading">Get in touch</Typography>
          <Box sx={{ display: "grid", justifyItems: "start", gap: 1.4 }}>
            <Link
              component="button"
              onClick={() => setIsFormOpen(true)}
              underline="none"
              sx={footerLinkStyles}
            >
              Make an enquiry <ArrowOutwardIcon sx={{ fontSize: 14, ml: 0.5 }} />
            </Link>
            <Link
              href="mailto:info@homelys.in"
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              sx={footerLinkStyles}
            >
              info@homelys.in
            </Link>
            <Link href="tel:+919937476041" underline="none" sx={footerLinkStyles}>
              +91 99374 76041
            </Link>
          </Box>
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <Typography className="footer-heading">Follow our journey</Typography>
          <Box sx={{ display: "flex", gap: 1.2 }}>
            {socialLinks.map((social) => (
              <Link
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.label}
                sx={{
                  width: 42,
                  height: 42,
                  display: "grid",
                  placeItems: "center",
                  border: "1px solid rgba(246,244,239,0.24)",
                  borderRadius: "50%",
                  transition: "background-color 200ms ease, border-color 200ms ease",
                  "&:hover": {
                    backgroundColor: "rgba(246,244,239,0.1)",
                    borderColor: "rgba(246,244,239,0.6)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={social.icon}
                  alt=""
                  sx={{
                    width: 16,
                    height: 16,
                    filter: "brightness(0) invert(1)",
                    opacity: 0.86,
                  }}
                />
              </Link>
            ))}
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "rgba(246,244,239,0.18)" }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1,
          pt: 2.2,
        }}
      >
        <Typography sx={{ color: "rgba(246,244,239,0.58)", fontSize: "0.72rem" }}>
          © {new Date().getFullYear()} Homely Buildofiy. All rights reserved.
        </Typography>
        <Typography sx={{ color: "rgba(246,244,239,0.42)", fontSize: "0.68rem" }}>
          Made with care in Odisha
        </Typography>
      </Box>
      <style>{`
        .footer-heading {
          margin-bottom: 18px !important;
          color: #c7b896;
          font-size: 0.68rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.14em !important;
          text-transform: uppercase;
        }
      `}</style>
    </Box>
  );
};

const footerLinkStyles = {
  display: "inline-flex",
  alignItems: "center",
  width: "fit-content",
  p: 0,
  color: "rgba(246,244,239,0.72)",
  fontSize: "0.86rem",
  textAlign: "left",
  transition: "color 180ms ease",
  "&:hover": { color: "#ffffff" },
};

export default Footer;
